"use client";

import Link from "next/link";
import { create } from "zustand";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type Store = {
  visible: boolean;
  toggle: () => void;
};

export const useRequiredAccountStore = create<Store>()((set) => ({
  visible: false,
  toggle: () => set((state) => ({ visible: !state.visible })),
}));

export const RequiredCreateAccount = () => {
  const { visible, toggle } = useRequiredAccountStore((state) => state);

  return (
    <Dialog open={visible} onOpenChange={(value) => (!value ? toggle() : null)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Crie sua conta ou faça login</DialogTitle>
          <DialogDescription>
            Para concluir a ação desejada, é necessário criar uma conta ou fazer
            login para finalizar a ação.
          </DialogDescription>
          <div className="pt-6 flex gap-2">
            <Button asChild variant="outline" onClick={toggle}>
              <Link href="/sign-up/">Criar conta</Link>
            </Button>
            <Button asChild onClick={toggle}>
              <Link href="/sign-in/">Fazer login</Link>
            </Button>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
